import { getMeasureMarkers } from './internal/utils';

export const clearTimer = (event: string) => {
  const { measureName, startEvent, endEvent } = getMeasureMarkers(event);

  performance.clearMarks(startEvent);
  performance.clearMarks(endEvent);
  performance.clearMeasures(measureName);
};
